var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChecklist(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#4A4A4A;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_12283",
    transform: "translate(-1542.561 -188.089)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12280",
    transform: "translate(1543.975 205.631)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M44.5,19.8h-23c-0.8,0-1.5-0.7-1.5-1.5s0.7-1.5,1.5-1.5h23c0.8,0,1.5,0.7,1.5,1.5S45.3,19.8,44.5,19.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M5.6,23.7l-5.5-5.2C-0.5,17.9-0.5,17,0,16.4c0.6-0.6,1.5-0.6,2.1-0.1l3.6,3.4l6.9-6c0.6-0.5,1.5-0.5,2.1,0.1 c0.5,0.6,0.5,1.5-0.1,2.1L5.6,23.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12281",
    transform: "translate(1543.975 197.566)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M44.5,16h-23c-0.8,0-1.5-0.7-1.5-1.5s0.7-1.5,1.5-1.5h23c0.8,0,1.5,0.7,1.5,1.5S45.3,16,44.5,16z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M5.6,19.9l-5.5-5.2c-0.6-0.6-0.6-1.5-0.1-2.1C0.6,12,1.5,12,2.1,12.6L5.7,16l6.9-6c0.6-0.5,1.5-0.5,2.1,0.1 c0.5,0.6,0.5,1.5-0.1,2.1L5.6,19.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12282",
    transform: "translate(1543.975 189.5)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M44.5,12.3h-23c-0.8,0-1.5-0.7-1.5-1.5s0.7-1.5,1.5-1.5h23c0.8,0,1.5,0.7,1.5,1.5S45.3,12.3,44.5,12.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M5.6,16.1l-5.5-5.2C-0.5,10.4-0.5,9.4,0,8.8c0.6-0.6,1.5-0.6,2.1-0.1l3.6,3.4l6.9-6c0.6-0.5,1.5-0.5,2.1,0.1 c0.5,0.6,0.5,1.5-0.1,2.1L5.6,16.1z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChecklist);
export default __webpack_public_path__ + "static/media/Check list.e1a3af4172b55f9936b2c9d341249d0f.svg";
export { ForwardRef as ReactComponent };